import {
  RouterProvider as RRDRouterProvider,
  type RouteObject,
  createBrowserRouter,
} from 'react-router-dom';

import { RootLayout } from '@/app/layout';
import { AVAILABLE_LANGUAGES } from '@/lib/i18n/constants';

import { accountRoutes } from './account/account.routes';
import { adminRoutes } from './admin/admin.routes';
import { authRoutes } from './auth/auth.routes';
import { coachRoutes } from './coach/coach.routes';
import { CvRoutes } from './cv/cv.routes';
import { interviewRoutes } from './interview/interview.routes';
import { legalRoutes } from './legal/legal.routes';
import { surveyRoutes } from './survey/survey.routes';

const createLanguageRoutes = (lang?: string): Array<RouteObject> => {
  const pathPrefix = lang ? `/${lang}` : '';

  return [
    {
      path: pathPrefix,
      element: <RootLayout />,
      children: [
        {
          path: '',
          lazy: () => import('../app/RootPage/page'),
        },
        {
          path: 'logout',
          lazy: () => import('../app/logout/page'),
        },
        accountRoutes,
        adminRoutes,
        interviewRoutes,
        surveyRoutes,
        coachRoutes,
        legalRoutes,
        CvRoutes,
        authRoutes,
      ],
    },
  ];
};

const routes = AVAILABLE_LANGUAGES.map((lang) =>
  createLanguageRoutes(lang.key)
).flat();
routes.push(...createLanguageRoutes()); // Routes without language prefix

export const router = createBrowserRouter(routes);

export function RouterProvider(): JSX.Element {
  return <RRDRouterProvider router={router} />;
}

// Clean up on module reload (HMR)
// https://vitejs.dev/guide/api-hmr
if (import.meta.hot) {
  import.meta.hot.dispose(() => router.dispose());
}
